document.addEventListener('DOMContentLoaded', function() {
  const faqSections = document.querySelectorAll('.bd-faq-section');
  
  faqSections.forEach(section => {
    const faqItems = section.querySelectorAll('.bd-faq-item');

    faqItems.forEach(item => {
      const questionWrapper = item.querySelector('.bd-faq-question-wrapper');
      
      if (questionWrapper) {
        questionWrapper.addEventListener('click', (e) => {
          e.stopPropagation();
          
          const answer = item.querySelector('.bd-faq-answer');
          const isCurrentlyActive = item.classList.contains('active');
          
          faqItems.forEach(i => {
            if (i !== item) {
              const otherAnswer = i.querySelector('.bd-faq-answer');
              i.classList.remove('active');
              if (otherAnswer) {
                otherAnswer.style.maxHeight = null;
              }
            }
          });
          
          if (isCurrentlyActive) {
            item.classList.remove('active');
            if (answer) {
              answer.style.maxHeight = null;
            }
          } else {
            item.classList.add('active');
            if (answer) {
              answer.style.maxHeight = answer.scrollHeight + 'px';
            }
          }
        });
      }
    });
  });
});